import React from 'react';
import FileIcon from './FileIcon';

const FileThumbnail = ({ record, style, source, title }) => (
  <div
    style={{
      ...style,
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 8,
    }}
  >
    <FileIcon
      size={48}
      fileName={record[source]}
      style={{
        marginBottom: 10,
      }}
    />
    {record[title]}
  </div>
);

export default FileThumbnail;
